import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { IconChevronTop, IconChevronBottom } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useRef, useState } from 'react';
import { Title } from '../../../../../../components/CountrySwitch/components/CountrySwitchMobile/components/MenuItem/components/Title.js';
import { NextImage } from '../../../../../../components/internal/NextImage/index.js';
import { Collapse, LabelMedium, Stack } from '../../../../../../primitives/index.js';
import { useDirectusImageUrl } from '../../../../../../utils/directus.js';
import { SPACING_SMALL } from '../../../../../../utils/spacingLegacy.js';
export const MenuItemCountry = ({
  children,
  activeCountry
}) => {
  const {
    t
  } = useTranslation();
  const [subMenuVisible, setSubMenuVisible] = useState(false);
  const ref = useRef(null);
  const image = useDirectusImageUrl(activeCountry?.icon?.url);
  // label should come from translations
  return _jsxs(_Fragment, {
    children: [_jsxs(Title, {
      ref: ref,
      onClick: () => setSubMenuVisible(!subMenuVisible),
      children: [_jsx(LabelMedium, {
        children: t('headerNew:countrySwitchTitle')
      }), _jsxs(Stack, {
        direction: "row",
        alignItems: "center",
        spacing: SPACING_SMALL,
        children: [activeCountry?.icon.url && _jsx(NextImage, {
          width: 21,
          height: 15,
          image: image,
          alt: ""
        }), children && (subMenuVisible ? _jsx(IconChevronTop, {}) : _jsx(IconChevronBottom, {}))]
      })]
    }), children && _jsx(Collapse, {
      in: subMenuVisible,
      children: children
    })]
  });
};